module.exports = __webpack_public_path__ + "static/img/job_6.d74a9546.png";